export const backendForLocalhost = 'https://portal-dev.thekingdombank.com'
